import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line
import { getDownloadAPI } from "@/store/restAPI.js";


// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {

  exportExcelOrder({ commit } , filter) {
    commit("SET_LOADING", true);
    return getDownloadAPI("export/exportExcelOrder" , filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveOrdersForExport({ commit } , filter) {
    commit("SET_LOADING", true);
    return getAPI("export/retrieveOrdersForExport" , filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  exportConsolidated({ commit } , filter) {
    commit("SET_LOADING", true);
    return getDownloadAPI("export/exportConsolidated" , filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },
};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };